import { Badge } from '@/components/ui/badge';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { CaretDown } from '@phosphor-icons/react';

export const RENEWAL_STATUS = {
  none:        { label: '— Aucun',       cls: 'bg-[#334155]/40 text-[#94A3B8] border-[#334155]' },
  contacted:   { label: 'Contacté',      cls: 'bg-[#3B82F6]/20 text-[#3B82F6] border-[#3B82F6]/30' },
  negotiating: { label: 'Négociation',   cls: 'bg-[#F59E0B]/20 text-[#F59E0B] border-[#F59E0B]/30' },
  renewed:     { label: 'Renouvelé',     cls: 'bg-[#10B981]/20 text-[#10B981] border-[#10B981]/30' },
  lost:        { label: 'Perdu',         cls: 'bg-[#EF4444]/20 text-[#EF4444] border-[#EF4444]/30' },
};

/**
 * Badge cliquable pour changer rapidement le statut de renouvellement d'un client.
 * @param {string} value - statut courant
 * @param {function(string)} onChange - callback appelé quand l'utilisateur change le statut
 * @param {string} clientId - pour data-testid
 * @param {boolean} readOnly - si true, affiche juste le badge sans dropdown
 */
const RenewalStatusBadge = ({ value = 'none', onChange, clientId = '', readOnly = false }) => {
  const s = RENEWAL_STATUS[value] || RENEWAL_STATUS.none;
  if (readOnly || !onChange) {
    return <Badge className={`${s.cls} text-xs`}>{s.label}</Badge>;
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md border text-xs ${s.cls} hover:opacity-80`}
          data-testid={`renewal-status-${clientId}`}
        >
          {s.label} <CaretDown size={10} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-[#0F172A] border-[#1E293B]">
        {Object.entries(RENEWAL_STATUS).map(([k, meta]) => (
          <DropdownMenuItem
            key={k}
            onClick={(e) => { e.stopPropagation(); onChange(k); }}
            className="text-[#F8FAFC] hover:bg-[#1E293B] cursor-pointer"
            data-testid={`renewal-opt-${k}`}
          >
            <span className={`inline-block w-2 h-2 rounded-full mr-2 ${meta.cls.split(' ')[0].replace('/20', '')}`} />
            {meta.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RenewalStatusBadge;
